import React from "react";
import { LOGO_URL, PHONES } from "../../content";
import { Phone, MapPin } from "lucide-react";

export default function Footer({ t }) {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-amber-900/30 bg-stone-950/70 backdrop-blur-md pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Hari Ram Purwar" className="h-14 w-14 rounded-full object-cover ring-2 ring-amber-600/40" />
            <div>
              <div className="font-serif text-2xl text-stone-50">Hari Ram Purwar</div>
              <div className="text-amber-500 text-[10px] uppercase tracking-[0.3em]">Since 1890</div>
            </div>
          </div>
          <p className="mt-5 text-stone-400 text-sm max-w-sm leading-relaxed">{t.tagline}</p>
        </div>

        <div className="md:col-span-4">
          <div className="text-stone-500 text-xs uppercase tracking-[0.3em] mb-4">{t.call}</div>
          <div className="space-y-2">
            {PHONES.map((p) => (
              <a
                key={p}
                href={`tel:${p}`}
                className="flex items-center gap-3 text-stone-200 hover:text-amber-500 transition-colors"
                data-testid={`footer-phone-${p}`}
              >
                <Phone size={16} className="text-amber-500" />
                <span className="font-serif text-xl">+91 {p}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-stone-500 text-xs uppercase tracking-[0.3em] mb-4">Address</div>
          <div className="flex items-start gap-3 text-stone-300 text-sm">
            <MapPin size={16} className="text-amber-500 mt-0.5 shrink-0" />
            <span>{t.address}</span>
          </div>
        </div>
      </div>

      <div className="amber-divider mt-14" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-stone-500 text-xs">© {year} Hari Ram Purwar. {t.rights}</p>
        <div className="flex items-center gap-4">
          <p className="text-stone-600 text-xs italic font-serif">Established 1890 · Meerapur · Prayagraj 211003</p>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="text-stone-600 hover:text-amber-500 text-xs uppercase tracking-[0.2em] transition-colors"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
